export interface AreaOfInterestItem {
  id: number | string;
  name: string;
}

export class AreaOfInterestHelper {
  static parseApiResponse(res: any): AreaOfInterestItem[] {
    const list = res?.data?.results || res?.data || res?.results || [];
    const items = Array.isArray(list) ? list : [];
    return items.map((x: any) => ({
      id: x.id ?? x.area_of_interest_id,
      name: x.name ?? x.ar_name ?? ''
    }));
  }

  static mergeLookupCache(cache: AreaOfInterestItem[], newItems: AreaOfInterestItem[]): void {
    for (const item of newItems) {
      if (item.id == null) continue;
      const numId = Number(item.id);
      if (!cache.some((i) => Number(i.id) === numId)) {
        cache.push(item);
      }
    }
  }

  static resolveSelectedItems(
    selected: any[],
    currentItems: AreaOfInterestItem[],
    lookupCache: AreaOfInterestItem[]
  ): AreaOfInterestItem[] {
    if (!Array.isArray(selected) || selected.length === 0) return [];

    const isIds = selected.every((x) => typeof x === 'number' || (typeof x === 'string' && !isNaN(Number(x))));

    if (isIds) {
      return (selected as (number | string)[])
        .map((id) => {
          const numId = typeof id === 'string' ? parseInt(id, 10) : Number(id);
          if (!Number.isInteger(numId) || numId <= 0) return null;
          return (
            currentItems.find((i) => Number(i.id) === numId) ??
            lookupCache.find((i) => Number(i.id) === numId) ?? { id: numId, name: String(id) }
          );
        })
        .filter((i): i is AreaOfInterestItem => i !== null);
    }

    return selected.map((x: any) => ({
      id: x.id ?? x.name,
      name: x.name ?? String(x.id)
    }));
  }

  static toPositiveIntegerIds(items: AreaOfInterestItem[]): number[] {
    return items
      .map((i) => (typeof i.id === 'string' ? parseInt(i.id, 10) : Number(i.id)))
      .filter((n) => Number.isInteger(n) && n > 0);
  }

  static toCustomNames(items: AreaOfInterestItem[]): string[] {
    return items
      .filter((i) => {
        const n = typeof i.id === 'string' ? parseInt(i.id, 10) : Number(i.id);
        return !Number.isInteger(n) || n <= 0;
      })
      .map((i) => (i.name || '').trim())
      .filter(Boolean);
  }
}
